import { render, staticRenderFns } from "./ListGroupMenu.vue?vue&type=template&id=d60e848e&"
import script from "./ListGroupMenu.vue?vue&type=script&lang=js&"
export * from "./ListGroupMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports